export default __webpack_public_path__ + "static/media/emirateLogo.123cc3c3.png";